module.exports = __webpack_public_path__ + "media/images/dooh_1280x960-bf9a3674.svg";